module.exports = __webpack_public_path__ + "img/retailMall-2.a9d64f9a.png";